import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/anomalies`;

export const anomalyService = {
  async listAnomalies(filters = {}) {
    const params = new URLSearchParams();
    if (filters.entity_type) params.append('entity_type', filters.entity_type);
    if (filters.severity) params.append('severity', filters.severity);
    if (filters.resolution_status) params.append('resolution_status', filters.resolution_status);
    if (filters.detection_method) params.append('detection_method', filters.detection_method);
    if (filters.limit) params.append('limit', filters.limit);
    const query = params.toString();
    const response = await axios.get(`${API_BASE}${query ? `?${query}` : ''}`);
    return response.data;
  },

  async getStats(entityType) {
    const params = entityType ? `?entity_type=${entityType}` : '';
    const response = await axios.get(`${API_BASE}/stats${params}`);
    return response.data;
  },

  async getAnomaliesForEntity(entityType, entityId) {
    const response = await axios.get(`${API_BASE}/${entityType}/${entityId}`);
    return response.data;
  },

  async resolveAnomaly(anomalyId, status, resolutionNotes) {
    const response = await axios.put(`${API_BASE}/${anomalyId}/resolve`, {
      status,
      resolution_notes: resolutionNotes,
    });
    return response.data;
  },
};

export default anomalyService;
